export default __webpack_public_path__ + "assets/832aad8860c6f31ed1d3c04411210e25.jpg";